export default __webpack_public_path__ + "static/media/ExploreTheDeep_00.30cdfc80.png";